module.exports = __webpack_public_path__ + "img/icon1.2f666fb5.png";